export const SET_TOKEN = 'SET_TOKEN';

export default function (value) {
    return {
        type: SET_TOKEN,
        value,
    };
}
